/* unplugin-vue-components disabled */import script from "./MonthHotCookbook.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthHotCookbook.vue?vue&type=script&setup=true&lang=js"

import "./MonthHotCookbook.vue?vue&type=style&index=0&id=0765e6e9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0765e6e9"]])

export default __exports__